import React from "react";
import { func, shape, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { statusTagColor } from "util/thirdPayment";
import FormattedAmount from "pages/_components/FormattedAmount";
import InfoTag from "pages/echeck/components/InfoTag";
import CustomData from "pages/_components/CustomData/CustomData";
import { transactionStatus } from "pages/transactions/constants";

const VendorsLotPaymentsItem = ({ receibedThirdPayment, onAnulate, isDesktop, withOptions }) => {
    const anulateOption = [
        {
            func: () => onAnulate(receibedThirdPayment.transaction.idTransaction),
            text: "lotPayment.cancel",
            textType: "I18N",
        },
    ];
    const getCodeMsg = (code) => {
        if (code === "PROCESSING") {
            return "EN PROCESO";
        }
        if (code === "FINISHED") {
            return "FINALIZADA";
        }
        if (code === "PENDING") {
            return "PENDIENTE";
        }
        if (code === "CANCELLED") {
            return "ANULADO";
        }
        if (code === "FAILED") {
            return "FALLIDA";
        }
        return code;
    };
    return (
        <>
            <GridTable.Data columnStart={1} rowStart={1} alignX="start">
                <CustomText text={receibedThirdPayment?.transaction?.idTransaction.substring(0, 8)?.toUpperCase()} />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2} alignX="center">
                <CustomText text={receibedThirdPayment?.transaction?.data?.accountInfo?.shortLabel} />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3} alignX="center">
            <FormattedDate date={receibedThirdPayment?.transaction?.data?.dateProcess} />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 4 : 1} rowStart={isDesktop ? 1 : 4} alignX="center">
                <CustomText text={receibedThirdPayment?.transaction?.data?.processedFileData?.validLines.toString()} />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 5 : 1} rowStart={isDesktop ? 1 : 5} alignX="center">
           <FormattedAmount
                            currency={receibedThirdPayment?.transaction?.data?.amount?.currency}
                            quantity={receibedThirdPayment?.transaction?.data?.amount?.quantity}
                        />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 6 : 2}
                rowStart={isDesktop ? 1 : 1}
                alignX={isDesktop ? "center" : "end"}
                alignY="center">
                <InfoTag
                    type="info"
                    message={getCodeMsg(receibedThirdPayment?.transaction?.idTransactionStatus)}
                    tagBackground={statusTagColor(receibedThirdPayment?.transaction?.idTransactionStatus)}
                />
            </GridTable.Data>
            {!!withOptions && (
                <GridTable.Data columnStart={isDesktop ? 7 : 1} rowStart={isDesktop ? 1 : 7} rowWidth={1} alignX="center">
                    {receibedThirdPayment?.transaction?.idTransactionStatus === transactionStatus.PENDING && (
                        <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={anulateOption} />
                    )}
                </GridTable.Data>
            )}
        </>
    );
};

VendorsLotPaymentsItem.propTypes = {
    receibedThirdPayment: shape(echeqPropTypes).isRequired,
    onAnulate: func.isRequired,
    isDesktop: bool.isRequired,
    withOptions: bool,
};

VendorsLotPaymentsItem.defaultProps = {
    withOptions: true,
};

export default VendorsLotPaymentsItem;
